import { getThemeCssClass, ThemeType } from '@/utils/theme';
import { ComponentProps, useEffect } from 'react';
import { ThemeContext, defaultTheme } from '@/components/core/theme-provider/theme-context';
import { useRootElement } from '@/hooks/use-root-element';

export { ThemeContext };

export type ThemeProviderProps = ComponentProps<typeof ThemeContext>;

export function ThemeProvider({ value = defaultTheme, ...props }: ThemeProviderProps) {
  const rootElement = useRootElement();

  useEffect(() => {
    if (!rootElement) return;

    const darkThemeClass = getThemeCssClass(ThemeType.Dark);

    rootElement.classList.toggle(darkThemeClass, value.theme === ThemeType.Dark);

    return () => {
      rootElement.classList.remove(darkThemeClass);
    };
  }, [value.theme, rootElement]);

  return <ThemeContext value={value} {...props} />;
}
